import {Language} from "./Language";
import {Locale} from "@js-joda/locale_en";

export const LangDutch: Language = {
	key: "nl-NL",
	locale: new Locale("nl"),
	// translations: {
	// 	"accountMenu:button:label": "Gebruiker",
	// 	"accountMenu:option:login": "Inloggen",
	// 	"accountMenu:option:logout": "Uitloggen",
	// 	"accountMenu:option:settings": "Instellingen",
	// 	"adnres:v1": "Geaccepteerd",
	// 	"adnres:v2": "Afgewezen",
	// 	"adnres:v3": "Acceptatie door Maatschappij",
	// 	"dynamicforms:questions:overview:grid:header:clientName": "Clientnaam",
	// 	"dynamicforms:questions:overview:grid:header:definition": "Definitie",
	// 	"dynamicforms:questions:overview:grid:header:frontEndName": "Frontend Naam",
	// 	"dynamicforms:questions:overview:grid:header:lastModifiedBy": "Laatst Aangepast Door",
	// 	"dynamicforms:questions:overview:grid:header:lastModifiedDateTime": "Laatst Aangepast Op",
	// 	"dynamicforms:questions:overview:grid:header:creationDateTime": "Aangemaakt Op",
	// 	"dynamicforms:questions:overview:grid:header:link": "Link",
	// 	"dynamicforms:editor:label:fullId": "Full ID",
	// 	"dynamicforms:editor:label:definition": "Definition",
	// 	"dynamicforms:editor:label:frontEndName": "Frontend Name",
	// 	"dynamicforms:editor:label:clientName": "Client Name",
	// 	"dynamicforms:editor:label:parameters": "Parameters",
	// 	"dynamicforms:editor:label:extends": "Extends",
	// 	"dynamicforms:editor:label:name": "Name",
	// 	"dynamicforms:editor:label:label": "Label",
	// 	"dynamicforms:editor:label:description": "Description",
	// 	"dynamicforms:editor:label:valueType": "Value Type",
	// 	"dynamicforms:editor:label:queryType": "Query Value",
	// 	"dynamicforms:editor:label:valueOptions": "Value Options (value-display)",
	// 	"dynamicforms:editor:label:unit": "Unit Type",
	// 	"dynamicforms:editor:label:defaultValue": "Default Value",
	// 	"dynamicforms:editor:label:mapping": "Mapping",
	// 	"dynamicforms:editor:label:defaultPositioning": "Default Positioning",
	// 	"dynamicforms:editor:label:missingRequiredValueErrorMessage": "Missing Required Value Message",
	// 	"dynamicforms:editor:label:valueMapping": "Value Mapping",
	// 	"dynamicforms:editor:label:defaultValueExpression": "Default Value Expression",
	// 	"dynamicforms:editor:label:labelExpression": "Label Expression",
	// 	"dynamicforms:editor:label:visibleExpression": "Visible Expression",
	// 	"dynamicforms:editor:label:enabledExpression": "Enabled Expression",
	// 	"dynamicforms:editor:label:editableExpression": "Editable Expression",
	// 	"dynamicforms:editor:label:requiredExpression": "Required Expression",
	// 	"dynamicforms:editor:label:validators": "Validators",
	// 	"dynamicforms:editor:label:custom": "Custom Properties",
	// 	"dynamicforms:editor:label:formName": "Form Name",
	// 	"dynamicforms:editor:label:clientId": "Client Name",
	// 	"dynamicforms:editor:label:remoteFormsNames": "Remote Forms Names",
	// 	"dynamicforms:editor:label:layout": "Layout",
	// 	"dynamicforms:editor:label:questions": "Questions",
	// 	"entityState:active": "Actief",
	// 	"entityState:deleted": "Verwijderd",
	// 	"language:name:en-gb": "Engels",
	// 	"language:name:nld": "Nederlands",
	// 	"orderStatus:queued": "In Wachtrij",
	// 	"orderStatus:processing": "In Verwerking",
	// 	"orderStatus:queuedForSaving": "Opslaan",
	// 	"orderStatus:underReview": "In Acceptatie",
	// 	"orderStatus:error": "Error",
	// 	"orderStatus:done": "Voltooid",
	// 	"orders:overview:grid:header:address": "Adres",
	// 	"orders:overview:grid:header:clientName": "Clientnaam",
	// 	"orders:overview:grid:header:processReference": "Procesreferentie",
	// 	"orders:overview:grid:header:email": "Email",
	// 	"orders:overview:grid:header:link": "Link",
	// 	"orders:overview:grid:header:orderId": "Aanvraag ID",
	// 	"orders:overview:grid:header:orderType": "Aanvraag Type",
	// 	"orders:overview:grid:header:policyId": "Polis ID",
	// 	"orders:overview:grid:header:productCategory": "Productcategorie",
	// 	"orders:overview:grid:header:productDescription": "Productomschrijving",
	// 	"orders:overview:grid:header:status": "Aanvraagstatus",
	// 	"orders:overview:grid:header:surname": "Achternaam",
	// 	"orders:overview:grid:header:transactionDate": "Datum",
	// 	"orders:overview:grid:header:underwritingResult": "Financiële Status",
	// 	"productIncentiveType:hello_fresh_coupon": "Hello Fresh Coupon",
	// 	"products:products:overview:grid:header:clientName": "Clientnaam",
	// 	"products:products:overview:grid:header:externalId": "Extern ID",
	// 	"products:products:overview:grid:header:dataProviderKrn": "Dataleverancier KRN",
	// 	"products:products:overview:grid:header:description": "Omschrijving",
	// 	"products:products:overview:grid:header:productSupplierKrn": "Productaanbieder KRN",
	// 	"products:products:overview:grid:header:productType": "Producttype",
	// 	"products:products:overview:grid:header:productTypeKrn": "Producttype KRN",
	// 	"products:products:overview:grid:header:orderType": "Aanvraagtype",
	// 	"products:products:overview:grid:header:productCategory": "Productcategorie",
	// 	"products:products:overview:grid:header:affiliateUrl": "Affiliate URL",
	// 	"products:products:overview:grid:header:insuranceCardUrl": "Verzekeringskaart URL",
	// 	"products:products:overview:grid:header:termsAndConditionsUrl": "Voorwaarden URL",
	// 	"products:products:overview:grid:header:supplierGenericProduct": "Is Generiek Product",
	// 	"products:suppliers:overview:grid:header:link": "Link",
	// 	"products:suppliers:overview:grid:header:krn": "KRN",
	// 	"products:suppliers:overview:grid:header:name": "Naam",
	// 	"products:suppliers:overview:grid:header:legalName": "Juridische Naam",
	// 	"products:suppliers:overview:grid:header:clientName": "Clientnaam",
	// 	"products:suppliers:overview:grid:header:productIncentiveType": "Beloningstype",
	// 	"products:suppliers:overview:grid:header:comparatorId": "Vergelijker ID",
	// 	"products:suppliers:overview:grid:header:lastModifiedBy": "Laatst Aangepast Door",
	// 	"products:suppliers:overview:grid:header:lastModifiedDateTime": "Laatst Aangepast Op",
	// 	"products:suppliers:overview:grid:header:state": "Status",
	// 	"productStatus:active": "Actief",
	// 	"productStatus:deleted": "Verwijderd",
	// 	"productSupplierStatus:active": "Actief",
	// 	"productSupplierStatus:deleted": "Verwijderd",
	// 	"productSupplierStatus:hidden": "Verborgen",
	// 	"productSupplierStatus:inactive": "Inactief",
	// 	"productOrderType:affiliate": "Affiliate",
	// 	"productOrderType:funnel_mga": "Funnel MGA",
	// 	"productOrderType:not_orderable": "Niet Aanvraagbaar",
	// 	"productCategory:non_specific": "Niet Gespecificeerd",
	// 	"productCategory:car": "Auto",
	// 	"productCategory:energy": "Energie",
	// 	"productCategory:home": "Opstal",
	// 	"productCategory:liability": "Aansprakelijkheid",
	// 	"productCategory:triple_play": "Triple Play",
	// 	"productCategory:travel": "Reis",
	// 	"productCategory:health_care": "Zorg",
	// 	"productCategory:funeral": "Begrafenis",
	// 	"productCategory:loan": "Lening",
	// 	"productCategory:sim_only": "Sim-Only",
	// 	"productCategory:animal": "Dier",
	// 	"productCategory:bike": "Fiets",
	// 	"sidebar:buildInfo:built": "Gebouwd:",
	// 	"sidebar:buildInfo:version": "Versie:",
	// 	"unauthorized:header": "Niet geauthoriseerd",
	// 	"unauthorized:logged-on": "U heeft niet genoeg rechten om deze pagina te zien.\nAls uw rechten recent zijn aangepast, probeer opnieuw in te loggen om de rechten te updaten.",
	// 	"unauthorized:no-user": "U moet ingelogd zijn om deze pagina te bezoeken, log a.u.b. in en probeer het opnieuw.",
	// 	"userSettings:header": "Instellingen",
	// 	"userSettings:setting:language:label": "Taal",
	// 	"userSettings:setting:colorTheme:label": "Kleur Thema",
	// 	"userSettings:setting:colorTheme:options:label:none": "Geen voorkeur",
	// 	"userSettings:setting:colorTheme:options:label:light": "Licht",
	// 	"userSettings:setting:colorTheme:options:label:dark": "Donker",
	// 	"userSettings:setting:colorTheme:options:label:systemDefault": "Systeem standaard",
	// 	"unknown": "Onbekend",
	// }
};
